export * from './useVendedorService'